/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Practice } from '../../models/practice';

export interface PracticesGetAllPractices$Params {
}

export function practicesGetAllPractices(http: HttpClient, rootUrl: string, params?: PracticesGetAllPractices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Practice>>> {
  const rb = new RequestBuilder(rootUrl, practicesGetAllPractices.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Practice>>;
    })
  );
}

practicesGetAllPractices.PATH = '/practices/availablepractices';
